import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class CatalogueDerivationError extends IncError {
    constructor(errorKey: string) {
        super(i18n.t(`error:catalogue.derivation.${errorKey}`));
        Object.setPrototypeOf(this, CatalogueDerivationError.prototype);
    }
}